import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close-thin",
  "use": "icon-close-thin-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"icon-close-thin\">\r\n<g>\r\n\t<polygon points=\"36,32.6 32.6,36 18,21.4 3.5,35.8 0.1,32.4 14.6,18 0,3.4 3.4,0 18,14.6 32.4,0.2 35.8,3.6 21.4,18 \t\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/close-thin.svg
// module id = 277
// module chunks = 0 1